import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
} from 'react-native';
// import { Auth } from '@aws-amplify/auth';
import { updateUserAttributes } from '@aws-amplify/auth';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';

import { AppSyncClientAuthenticated, AppSyncClientUnauthenticated } from '../../../backends/AppSyncClient';
import { AppSyncClientCreate } from '../../../backends/AppSyncClientCreate';
import GetMyApp from '../../../q/create/GetMyApp';
import GetMyApps from '../../../q/create/GetMyApps';
import ChangeAppApp from '../../../q/create/ChangeAppApp';
import ChangeAppGuide from '../../../q/create/ChangeAppGuide';
import ChangeAppLocation from '../../../q/create/ChangeAppLocation';
import ChangeAppPrice from '../../../q/create/ChangeAppPrice';
import ChangeAppLinks from '../../../q/create/ChangeAppLinks';
import ChangeAppReview from '../../../q/create/ChangeAppReview';
import ChangeAppDelete from '../../../q/create/ChangeAppDelete';
import PreviewApp from '../../../q/create/PreviewApp';
import PublishApp from '../../../q/create/PublishApp';
import GetUser from '../../../q/GetUser';
import AddUserImage from '../../../q/AddUserImage';
// import GetMyUser from '../../../q/GetMyUser';
import UpdateUser from '../../../q/UpdateUser';
import GetApp from '../../../q/GetApp';
import App from '../../../modules/data/App';
import PublisherAppFormApp from '../../../components/forms/app/Page1App';
import PublisherAppFormGuide from '../../../components/forms/app/Page2Guide';
import PublisherAppFormEndpoints from '../../../components/forms/app/Page3Endpoints';
import PublisherAppFormFinancial from '../../../components/forms/app/Page4Financial';
import PublisherAppFormLinks from '../../../components/forms/app/Page5Links';
import PublisherAppFormReview from '../../../components/forms/app/Page6Review';

import { currency } from '../../../money';
import AORTypes from '../../../types';
import styles from '../../../styles';
import { translate } from '../../../locales/i18n';
import withContext from '../../../context';

class PublisherAppEdit extends React.Component {
  static getPage(props) {
    const { context, app } = props;

    if (!app || !app.data || !app.data.uuid) {
      return 1;
    }

    console.log('context');
    console.log(context);

    return context.createAppPage[app.data.uuid] || 1;
  }

  static getDerivedStateFromProps(props, state) {
    const propsPage = PublisherAppEdit.getPage(props);
    const { statePage } = state;

    if (propsPage && propsPage !== statePage) {
      return {
        page: propsPage,
      };
    }

    return null;
  }

  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PublisherAppEdit';

    this.onPageSwitch = this.onPageSwitch.bind(this);
    this.onPage1Save = this.onPage1Save.bind(this);
    this.onPage2Save = this.onPage2Save.bind(this);
    this.onPage3Save = this.onPage3Save.bind(this);
    this.onPage4Save = this.onPage4Save.bind(this);
    this.onPage5Save = this.onPage5Save.bind(this);
    this.onPage6Save = this.onPage6Save.bind(this);
    this.onPage6SavePreview = this.onPage6SavePreview.bind(this);
    this.onPage6SavePublish = this.onPage6SavePublish.bind(this);
    this.onGoBackToApps = this.onGoBackToApps.bind(this);

    this.state = {
      page: PublisherAppEdit.getPage(this.props),
    };
  }

  onPageSwitch(page) {
    const { context, app } = this.props;

    console.log('page');
    console.log(page);

    context.createAppPage[app.data.uuid] = page;
    this.setState({ page });
  }

  async onPage1Save(values) {
    const { app, onPage1Save } = this.props;

    app.data.lang = values.lang;
    app.data.name = values.appName;
    app.data.desc = values.appDesc;

    return onPage1Save(app)
      .then(() => null)
      .catch((err) => {
        console.log('failed to save the page 1');
        console.log(err.message);
        return err.message;
      });
  }

  async onPage2Save(values) {
    const {
      app, user, userData, onUpdateUserLocal, onPage2Save,
    } = this.props;

    const { uuid: uuidUser, image } = userData;
    let { langs } = userData;
    const name = values.guideName;
    let descObj = {};
    try {
      descObj = JSON.parse(userData.desc);
    } catch (error) {
      console.log('failed parsing the app description');
      console.log(error);
    }
    if (descObj !== null) {
      descObj[app.data.lang] = values.guideDesc;
    } else {
      descObj = {};
    }
    const desc = JSON.stringify(descObj);

    app.data.guideName = values.guideName;
    app.data.guideDesc = values.guideDesc;
    app.data.guideImage = image;

    try {
      const langsObj = JSON.parse(langs);
      if (!langsObj.includes(app.data.lang)) {
        langsObj.push(app.data.lang);
      }
      langs = JSON.stringify(langsObj);
    } catch (error) {
      console.log('failed parsing the user languages');
    }

    return updateUserAttributes({
      userAttributes: {
        preferred_username: name,
      }
    })
      .then(() => {
        user.attributes.preferred_username = name;

        return Auth.currentAuthenticatedUser({ bypassCache: true })
          .then(() => {
            console.log('Auth.currentAuthenticatedUser succeeded');

            return onUpdateUserLocal({
              uuid: uuidUser, name, desc, image, langs,
            })
              .then(() => {
                console.log('done updating the user, now updating the app');
                // updateUserData();

                return onPage2Save(app)
                  .then(() => null)
                  .catch((err) => {
                    console.log('failed to save the page 2');
                    console.log(err.message);
                    return err.message;
                  });
              })
              .catch((err) => {
                console.log('error in onUpdateUser');
                console.log(err);
                return err.message;
              });
          });
      })
      .catch((err) => {
        let error = err.message;
        if (err.code === 'AliasExistsException') {
          error = translate('create_app_guide_exists');
        }
        return error;
      });
  }

  onPage3Save(values) {
    const { app, onPage3Save } = this.props;

    app.data.travelType = values.travelType;
    app.data.endpointIds = values.endpointIds;
    app.data.bounds = values.bounds;
    app.data.legs = values.legs;
    app.data.route = values.route;
    app.data.routeduration = values.routeduration;
    app.data.routelen = values.routelen;

    return onPage3Save(app)
      .then(() => null)
      .catch((err) => {
        console.log('failed to save the page 3');
        console.log(err.message);
        return err.message;
      });
  }

  onPage4Save(values) {
    const { app, onPage4Save } = this.props;

    app.data.type = values.type;
    app.data.currency = currency;
    app.data.rentPrice = values.rentPrice;
    app.data.rentDays = values.rentDays;
    app.data.buyPrice = values.buyPrice;

    return onPage4Save(app)
      .then(() => null)
      .catch((err) => {
        console.log('failed to save the page 4');
        console.log(err.message);
        return err.message;
      });
  }

  async onPage5Save(values) {
    const { app, onPage5Save } = this.props;

    app.data.linkWeb = values.web;
    app.data.linkYoutube = values.youtube;
    app.data.linkFacebook = values.facebook;
    app.data.linkInstagram = values.instagram;
    app.data.linkTwitter = values.twitter;

    return onPage5Save(app)
      .then(() => null)
      .catch((err) => {
        console.log('failed to save the page 5');
        console.log(err.message);
        return err.message;
      });
  }

  onPage6Save(values) {
    const { app, onPage6Save } = this.props;

    app.data.promoted = values.promoted;

    return onPage6Save(app)
      .then(() => {
        console.log('publishing...');

        return null;
      })
      .catch((err) => {
        console.log('failed to save the page 6');
        console.log(err.message);
        return err.message;
      });
  }

  onPage6SavePreview(values) {
    const { app, onPage6SavePreview } = this.props;

    app.data.promoted = values.promoted;

    return onPage6SavePreview(app)
      .then(() => AppSyncClientUnauthenticated.query({
        query: GetApp,
        variables: { uuid: app.data.uuid },
        fetchPolicy: 'no-cache',
      }))
      .then(() => null)
      .catch((err) => {
        console.log('failed to preview');
        console.log(err.message);
        return err.message;
      });
  }

  onPage6SavePublish(values) {
    const { app, onPage6SavePublish } = this.props;

    app.data.promoted = values.promoted;

    return onPage6SavePublish(app)
      .then(() => null)
      .catch((err) => {
        console.log('failed to publish');
        console.log(err.message);
        return err.message;
      });
  }

  onGoBackToApps() {
    const { user, history } = this.props;

    history.push(`/publisher/${user.attributes.sub}`);
  }

  render() {
    const {
      direction, app, history, user, onRefresh, userData, updateUserData, getUploader, getDirectionsService,
      onAddUserImage,
      onDelete,
      getAnalyticsService,
    } = this.props;
    const { page } = this.state;

    console.log('page');
    console.log(page);

    if (!app || !app.data || !userData) {
      return (
        <>
        </>
      );
    }

    return (
      <View style={styles.view.headed}>
        <View style={styles.view.form}>
          {/* Bredcrumbs is not here because it needs to know if the form is dirty  */}
          {/* TODO(clairbee): stop passing 'app' here, contain logic in this module */}
          {page === 1 && (
            <PublisherAppFormApp
              userData={userData}
              app={app}
              direction={direction}
              onCancel={this.onGoBackToApps}
              onPageSwitch={this.onPageSwitch}
              onSave={this.onPage1Save}
              getAnalyticsService={getAnalyticsService}
            />
          )}
          {page === 2 && (
            <PublisherAppFormGuide
              user={user}
              userData={userData}
              onAddUserImage={onAddUserImage}
              updateUserData={updateUserData}
              app={app}
              onCancel={this.onGoBackToApps}
              onPageSwitch={this.onPageSwitch}
              onSave={this.onPage2Save}
              getUploader={getUploader}
              direction={direction}
              history={history}
              getAnalyticsService={getAnalyticsService}
            />
          )}
          {page === 3 && (
            <PublisherAppFormEndpoints
              userData={userData}
              app={app}
              direction={direction}
              history={history}
              getDirectionsService={getDirectionsService}
              onCancel={this.onGoBackToApps}
              onPageSwitch={this.onPageSwitch}
              onSave={this.onPage3Save}
              onRefresh={onRefresh}
              updateUserData={updateUserData}
              getAnalyticsService={getAnalyticsService}
            />
          )}
          {page === 4 && (
            <PublisherAppFormFinancial
              app={app}
              onCancel={this.onGoBackToApps}
              onPageSwitch={this.onPageSwitch}
              onSave={this.onPage4Save}
              getAnalyticsService={getAnalyticsService}
              direction={direction}
            />
          )}
          {page === 5 && (
            <PublisherAppFormLinks
              app={app}
              onCancel={this.onGoBackToApps}
              onPageSwitch={this.onPageSwitch}
              onSave={this.onPage5Save}
              getAnalyticsService={getAnalyticsService}
              direction={direction}
            />
          )}
          {page === 6 && (
            <PublisherAppFormReview
              app={app}
              direction={direction}
              history={history}
              onCancel={this.onGoBackToApps}
              onDelete={onDelete}
              onPageSwitch={this.onPageSwitch}
              onSave={this.onPage6Save}
              onSavePreview={this.onPage6SavePreview}
              onSavePublish={this.onPage6SavePublish}
              getAnalyticsService={getAnalyticsService}
            />
          )}
        </View>
      </View>
    );
  }
}

PublisherAppEdit.defaultProps = {
  app: new App(),
  user: null,
  userData: null,
};

PublisherAppEdit.propTypes = {
  context: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  app: PropTypes.instanceOf(App),
  updateUserData: PropTypes.func.isRequired,
  onAddUserImage: PropTypes.func.isRequired,
  onUpdateUserLocal: PropTypes.func.isRequired,
  getUploader: PropTypes.func.isRequired,
  onPage1Save: PropTypes.func.isRequired,
  onPage2Save: PropTypes.func.isRequired,
  onPage3Save: PropTypes.func.isRequired,
  onPage4Save: PropTypes.func.isRequired,
  onPage5Save: PropTypes.func.isRequired,
  onPage6Save: PropTypes.func.isRequired,
  onPage6SavePreview: PropTypes.func.isRequired,
  onPage6SavePublish: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  userData: AORTypes.User,
  user: AORTypes.AWS.Cognito.User,
  getDirectionsService: PropTypes.func.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  direction: PropTypes.string.isRequired,
};

const changeOptions = (props) => ({
  refetchQueries: [{
    query: GetMyApp,
    variables: { uuid: props.uuid },
    client: AppSyncClientCreate(props.user),
  }, {
    query: GetMyApps,
    client: AppSyncClientCreate(props.user),
  }],
  client: AppSyncClientCreate(props.user),
});

export default compose(
  graphql(AddUserImage, {
    // name: 'AddEndpointImage',
    props: (props) => ({
      onAddUserImage: ({
        uuid, name, isVertical, lat, lon, type,
      }) => props.mutate({
        variables: {
          uuid: props.match.params.uuid,
          name,
          isVertical,
          lat,
          lon,
          type,
        },
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   updateEndpoint:
        //     endpoint.makeOptimistic().output(),
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetUser,
        variables: { uuid: props.user && props.user.attributes.sub },
        client: AppSyncClientAuthenticated(props.user),
      }],
      // fetchPolicy: 'no-cache',
      client: AppSyncClientAuthenticated(props.user),
    }),
  }),
  graphql(GetMyApp, {
    // props: props => ({
    //   app: props.data.getMyApps,
    // }),
    props: (props) => {
      console.log('graphql props');
      console.log(props);
      const app = App.createFromData(props.data.getMyApps);
      if (app && app.data && app.data.endpoints === undefined) {
        app.data.endpoints = [];
      }
      return {
        onRefresh: props.data.refetch,
        app,
      };
    },
    options: (props) => ({
      variables: {
        uuid: props.match.params.uuid,
      },
      client: AppSyncClientCreate(props.user),
      // fetchPolicy: 'no-cache',
      // fetchPolicy: 'cache-and-network',
      fetchPolicy: 'network-only', // make sure to get the latest as lambda functions do change them
    }),
    // client: AppSyncClientCreate(props.user),
  }),
  graphql(ChangeAppApp, {
    props: ({ mutate }) => ({
      onPage1Save: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
          lang: app.data.lang,
          name: app.data.name,
          desc: app.data.desc,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(ChangeAppGuide, {
    props: ({ mutate }) => ({
      onPage2Save: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
          guideName: app.data.guideName,
          guideDesc: app.data.guideDesc,
          guideImage: app.data.guideImage,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(ChangeAppLocation, {
    props: ({ mutate }) => ({
      onPage3Save: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
          travelType: app.data.travelType,
          endpointIds: app.data.endpointIds,
          // TODO(clairbee): app position is not yet configurable on the page 3
          // lat: app.data.lat
          // lon: app.data.lon,
          // coords: app.data.coords,
          bounds: app.data.bounds,
          route: app.data.route,
          legs: app.data.legs,
          routeduration: app.data.routeduration,
          routelen: app.data.routelen,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(ChangeAppPrice, {
    props: ({ mutate }) => ({
      onPage4Save: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
          type: app.data.type,
          currency: app.data.currency,
          rentPrice: app.data.rentPrice,
          rentDays: app.data.rentDays,
          buyPrice: app.data.buyPrice,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(ChangeAppLinks, {
    props: ({ mutate }) => ({
      onPage5Save: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
          linkWeb: app.data.linkWeb,
          linkYoutube: app.data.linkYoutube,
          linkFacebook: app.data.linkFacebook,
          linkInstagram: app.data.linkInstagram,
          linkTwitter: app.data.linkTwitter,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(ChangeAppDelete, {
    props: ({ mutate }) => ({
      onDelete: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(ChangeAppReview, {
    props: ({ mutate }) => ({
      onPage6Save: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
          promoted: app.data.promoted,
          completed: app.data.completed,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(PreviewApp, {
    props: ({ mutate }) => ({
      onPage6SavePreview: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(PublishApp, {
    props: ({ mutate }) => ({
      onPage6SavePublish: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(UpdateUser, {
    props: (props) => ({
      onUpdateUserLocal:
        (args) => {
          const {
            uuid, name, desc, image, langs,
          } = args;

          console.log('args');
          console.log(args);
          console.log('uuid');
          console.log(uuid);
          return props.mutate({
            variables: {
              uuid,
              name,
              desc,
              image,
              langs,
            },
            // optimisticResponse: () => {
            //   const result = {
            //     uuid,
            //     name,
            //     desc,
            //     image,
            //     langs,
            //   };
            //   result['__typename'] = 'Users'; // eslint-disable-line dot-notation
            //   return {
            //     updateUsers: result,
            //     getMyUsers: result,
            //   };
            // },
          });
        },
    }),
    options: (props) => ({
      // refetchQueries: [{
      //   query: GetMyUser,
      //   variables: { uuid: props.user && props.user.attributes.sub },
      // }],
      // awaitRefetchQueries: false,
      fetchPolicy: 'no-cache',
      client: AppSyncClientAuthenticated(props.user),
    }),
  })
)(withContext(PublisherAppEdit));
